import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/site';
type PageHeroProps = {
  eyebrow: string;
  title: string;
  text: string;
  image?: string;
  imageAlt?: string;
};
export function PageHero({
  eyebrow,
  title,
  text,
  image,
  imageAlt
}: PageHeroProps) {
  return <section className="border-b border-line bg-navy-800" data-id="element-106" data-mp="25lk1x3hywjf">
      <div className="mx-auto max-w-content px-5 pb-14 pt-8 lg:px-8 lg:pb-20 lg:pt-12" data-id="element-107" data-mp="pu4sqdqglbc1">
        <nav aria-label="Fil d'ariane" className="mb-8 lg:mb-10" data-id="element-108" data-mp="usg2kogr7lu9">
          <ol className="flex items-center gap-1.5 text-sm text-navy-200" data-id="element-109" data-mp="g3a1sw29pnk9">
            <li data-id="element-110" data-mp="g17cyfcuq0h4">
              <Link to="/" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-111" data-mp="l2d96n5q05ve">
                Accueil
              </Link>
            </li>
            <li aria-hidden="true" data-id="element-112" data-mp="1dio08r1opk32">
              <ChevronRightIcon className="h-4 w-4 text-navy-400" data-id="element-113" data-mp="1djpj3hoxzavc" />
            </li>
            <li className="font-medium text-white" aria-current="page" data-id="element-114" data-mp="32hiw33uofl6m">
              {eyebrow}
            </li>
          </ol>
        </nav>

        <div className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-14" data-id="element-115" data-mp="2xl26e57twyrf">
          <div className="lg:col-span-7" data-id="element-116" data-mp="3c8x0nq1hjb6m">
            <p className="font-display text-sm font-bold uppercase tracking-[0.16em] text-ember-300" data-id="element-117" data-mp="37hf0333djcm6">
              {eyebrow}
            </p>
            <h1 className="mt-3 font-display text-[2.1rem] font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl" data-id="element-118" data-mp="3l7s815g9mrbi">
              {title}
            </h1>
            <p className="mt-5 max-w-xl text-[1.05rem] leading-relaxed text-navy-100" data-id="element-119" data-mp="3v6ptfziea4qa">
              {text}
            </p>
            <a href={company.phoneHref} className="mt-8 inline-flex items-center gap-2.5 whitespace-nowrap rounded-xl bg-ember-500 px-6 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-ember-600" data-id="element-120" data-mp="3q7myx901jgwk">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-121" data-mp="2liiz3y2ychk6" />
              {company.phone}
            </a>
          </div>

          {image && <div className="lg:col-span-5" data-id="element-122" data-mp="2plp4z4m5k6q4">
              <img src={image} alt={imageAlt ?? ''} className="aspect-[4/3] w-full rounded-2xl object-cover shadow-lift" loading="lazy" data-id="element-123" data-mp="2uifusjnregoq" />
            </div>}
        </div>
      </div>
    </section>;
}